import { render } from "./Icon.vue?vue&type=template&id=07103dc6&scoped=true"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-07103dc6"

export default script